import React from 'react';

function Hero() {
  return (
    <div className="pt-0 pb-8 md:pb-12 space-y-8 -mt-4">

      {/* Hidden SEO Content - Visible to search engines but not users */}
      <div className="sr-only" aria-hidden="true">
        <h1>Rezonata Labs - AI Company Building Intelligent Applications</h1>
        <h2>About Rezonata Labs</h2>
        <p>Rezonata Labs is a leading artificial intelligence company that specializes in building intelligent applications and AI-powered solutions for businesses. Founded in 2024, Rezonata Labs focuses on making cutting-edge AI technology accessible and practical for professionals and organizations worldwide.</p>
        
        <h2>Rezonata Labs Mission</h2>
        <p>The mission of Rezonata Labs is to bridge the gap between emerging AI capabilities and practical business applications. Rezonata Labs creates tools that enhance human potential while automating complex processes, helping businesses transform their operations through intelligent automation and data-driven insights.</p>
        
        <h2>Rezonata Labs Products and Services</h2>
        <p>Rezonata Labs offers comprehensive AI solutions including KinOS, an AI-driven marketing platform for coaches and consultants. Rezonata Labs develops intelligent business tools, professional development software, and automation solutions that leverage emerging AI technologies.</p>
        
        <h2>Rezonata Labs Technology</h2>
        <p>Rezonata Labs leverages artificial intelligence and emerging technologies to create innovative software solutions. Rezonata Labs combines AI capabilities with practical business applications, helping organizations harness technological advancement for tangible business growth.</p>
        
        <h2>Rezonata Labs Keywords</h2>
        <p>Rezonata Labs, AI company, artificial intelligence, intelligent applications, business automation, professional development, KinOS, coaching software, AI solutions, emerging technologies, intelligent software, business transformation, AI-powered tools, Rezonata Labs Inc, intelligent automation, data-driven insights.</p>
      </div>

      {/* About Us Section */}
      <section>
        <h2 className="text-2xl md:text-3xl font-bold text-white mb-6">Building for agency</h2>
        <div className="space-y-4 text-gray-300 leading-relaxed">
          <p>
            At Rezonata Labs, we build systems that amplify human intention.
          </p>
          <p>
         Our work is about dissolving the friction between a thought and its tangible result. We architect the underlying layers that allow human agency, creativity, and connection to flow without resistance. This is the new infrastructure for progress, built not for the world as it is, but for the world as it could be.
          </p>
          <p>
            We are engineers, builders, and explorers inventing at the edge of possibility. If you want to shape the paradigms that come next, <a href="mailto:team@rezonata.xyz?subject=I'm interested in joining Rezonata Labs&body=Hi team,%0D%0A%0D%0AI'm interested in learning more about opportunities at Rezonata Labs and how I might contribute to your mission.%0D%0A%0D%0ABest regards" className="text-white font-bold underline hover:text-gray-300 transition-colors duration-300">join us</a>.
          </p>
        </div>
      </section>
        
      {/* KinOS Product Section */}
      <section>
        <p className="text-gray-300 leading-relaxed">
          Our <a href="https://www.kolanut.ai" target="_blank" rel="noopener noreferrer" className="text-white font-bold underline hover:text-gray-300 transition-colors duration-300">work</a> already empowers entrepreneurs and businesses to turn intentions into action and deliver value faster.
        </p>
      </section>
    </div>
  );
}

export default Hero;